import React from 'react';
import { Container } from '../Container';
import { DataField, DataSet } from '../Data';
import moment from 'moment';
import {getOrderById} from "../../api/AWSAPI";

class OrderSidebar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: props.id,
            orderStatus: 0,
            courierCode: '',
            clientName: '',
            clientPO: '',
            contactName: '',
            contactEmail: '',
            contactLine1: '',
            contactLine2: '',
            contactTown: '',
            contactPostcode: '',
            recipientCompany: '',
            recipientName: '',
            recipientEmail: '',
            recipientLine1: '',
            recipientLine2: '',
            recipientTown: '',
            recipientPostcode: '',
            copyAddress: false,
            contactTel: '',
            fundsReceived: '',
            transRef: '',
            contactCountry: '',
            recipientCountry: '',
            recipientTel: '',
        };
    }

    componentDidMount() {
        this.loadOrder();
    }

    loadOrder() {
        getOrderById(this.state.id, (data) => {
            if (data && data.success && data.order.length > 0) {
                const order = data.order[0];
                this.setState({
                    clientName: order.contactCompany,
                    orderStatus: order.orderStatus,
                    clientPO: order.clientPO,
                    contactName: order.contactName,
                    contactEmail: order.contactEmail,
                    contactLine1: order.contactLine1,
                    contactLine2: order.contactLine2,
                    contactTown: order.contactTown,
                    contactPostcode: order.contactPostcode,
                    recipientCompany: order.recipientCompany,
                    recipientName: order.recipientName,
                    recipientEmail: order.recipientEmail,
                    recipientLine1: order.recipientLine1,
                    recipientLine2: order.recipientLine2,
                    recipientTown: order.recipientTown,
                    recipientPostcode: order.recipientPostcode,
                    copyAddress: order.copyAddress,
                    contactTel: order.contactTel,
                    contactCountry: order.contactCountry,
                    recipientCountry: order.recipientCountry,
                    recipientTel: order.recipientTel,
                    fundsReceived: order.paymentReceivedDate,
                    transRef: order.paymentReference
                });
            }
        });
    }

    render() {
        return (
            <Container>
                {(parseInt(this.state.orderStatus) === 2 || parseInt(this.state.orderStatus) === 3) &&
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label className="sidebar-label">Payment Details</label>
                                <div className="sidebar-text">{moment(this.state.fundsReceived).format("DD MMM YY")} - Ref: {this.state.transRef}</div>
                            </div>
                        </div>
                    </div>
                }
                {this.state.courierCode &&
                    <div className="row">
                        <div className="col-sm-12">
                            <DataField label="Courier Code" value={this.state.courierCode} />
                        </div>
                    </div>
                }
                {this.state.clientPO &&
                    <div className="row">
                        <div className="col-sm-12">
                            <DataField label="Client PO/Reference" value={this.state.clientPO} />
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col-sm-12">
                        <DataSet label="Contact">
                            <p>{this.state.contactName}<br />
                                {this.state.clientName}<br />
                                {this.state.contactLine1}<br />
                                {this.state.contactLine2 ? <span>{this.state.contactLine2}<br /></span> : ''}
                                {this.state.contactTown}<br />
                                {this.state.contactPostcode}<br />
                                {this.state.contactCountry === 'IR' ? 'Republic of Ireland' : 'United Kingdom'}</p>
                            <p>{this.state.contactEmail}<br />
                                {this.state.contactTel}</p>
                        </DataSet>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <DataSet label="Recipient">
                            {this.state.copyAddress ?
                                <div>
                                    <p>{this.state.contactName}<br />
                                        {this.state.clientName}<br />
                                        {this.state.contactLine1}<br />
                                        {this.state.contactLine2 ? <span>{this.state.contactLine2}<br /></span> : ''}
                                        {this.state.contactTown}<br />
                                        {this.state.contactPostcode}<br />
                                        {this.state.contactCountry === 'IR' ? 'Republic of Ireland' : 'United Kingdom'}</p>
                                    <p>{this.state.contactEmail}<br />
                                        {this.state.contactTel}</p>
                                </div>
                                :
                                <div>
                                    <p>{this.state.recipientName}<br />
                                        {this.state.recipientCompany}<br />
                                        {this.state.recipientLine1}<br />
                                        {this.state.recipientLine2 ? <span>{this.state.recipientLine2}<br /></span> : ''}
                                        {this.state.recipientTown}<br />
                                        {this.state.recipientPostcode}<br />
                                        {this.state.recipientCountry === 'IR' ? 'Republic of Ireland' : 'United Kingdom'}</p>
                                    <p>{this.state.recipientEmail}<br />
                                        {this.state.recipientTel}</p>
                                </div>}
                        </DataSet>
                    </div>
                </div>
            </Container>
        )
    }

};

export default OrderSidebar;
